module.exports = __webpack_public_path__ + "img/info.a6eca802.svg";